<template>
  <v-form ref="form" v-model="formIsValid">
    <v-container class>
      <v-row class="contentRow">
        <v-col cols="12">
          <v-alert type="error">The use of this page requires an official Orixe API Key.</v-alert>
          <h1>Add Peer</h1>
        </v-col>
        <v-col cols="3">
          <v-subheader>Node Type</v-subheader>
        </v-col>
        <v-col cols="9">
          <v-select
            outlined
            :rules="typeRules"
            v-model="type"
            :items="types"
            label="Select type..."
          />
        </v-col>

        <v-col cols="3">
          <v-subheader>IP Address</v-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field label="IP Address..." outlined v-model="ipaddress" :rules="ipaddressRules" />
        </v-col>

        <v-col cols="3">
          <v-subheader>Port Number</v-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field label="Port Number" outlined v-model="portnumber" :rules="portnumberRules" />
        </v-col>

        <v-col cols="3">
          <v-subheader>Services</v-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field label="Services (not required)" outlined v-model="services" />
        </v-col>

        <v-col cols="3">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field label="Location" outlined v-model="location" :rules="locationRules" />
        </v-col>

        <v-col cols="3">
          <v-subheader>API Key</v-subheader>
        </v-col>
        <v-col cols="9">
          <v-text-field label="API Key" outlined v-model="apikey" :rules="apikeyRules" />
        </v-col>
      </v-row>
      <v-row class="contentRow">
        <v-col>
          <h2 class="mb-3">Summary</h2>
          <v-card class="mx-auto" outlined>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Node Type {{type ? "" : "(empty)"}}</v-list-item-subtitle>
                <v-list-item-title>{{type}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>IP Address {{ipaddress ? "" : "(empty)"}}</v-list-item-subtitle>
                <v-list-item-title>{{ipaddress}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Port Number {{portnumber ? "" : "(empty)"}}</v-list-item-subtitle>
                <v-list-item-title>{{portnumber}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Services {{services ? "" : "(empty)"}}</v-list-item-subtitle>
                <v-list-item-title>{{services}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Location {{location ? "" : "(empty)"}}</v-list-item-subtitle>
                <v-list-item-title>{{location}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>API Key {{apikey ? "" : "(empty)"}}</v-list-item-subtitle>
                <v-list-item-title>{{apikey}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <h3 class="mt-3">This is what your request will look like:</h3>
          <pre>
            <code class="d-block">
              Headers:
              X-API-KEY={{apikey}}

              Request body:
              {
                "type": "{{type}}",
				"ip": "{{ipaddress}}",
				"port": "{{portnumber}}",
				"services": "{{services}}",
				"location": "{{location}}"
              }
            </code>
          </pre>

          <v-btn
            color="success"
            :disabled="!formIsValid"
            v-on:click="sendRequest"
            v-if="!isSending"
          >
            <span>Send Request</span>
          </v-btn>
          <v-btn color="error" class="ml-3" v-on:click="resetForm" v-if="!isSending">
            <span>Reset Form</span>
          </v-btn>
          <div
            v-if="!formIsValid"
            class="mt-2 font-italic secondary--text"
          >Please correct the input data before sending the request</div>

          <v-dialog v-model="isSending" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                <p class="pt-3">Please stand by</p>
                <v-progress-linear indeterminate color="white" class="mb-0 mt-3"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-spacer />
          <v-progress-circular v-if="isSending" indeterminate></v-progress-circular>
        </v-col>
        <results-dialog :result="result" message="Peer was added! We are now connecting!"/>
        <error-dialog :error="error" />
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import API from "../../api/api"

export default {
  name: "AddPeer",
  data: () => ({
    type: null,
    ipaddress: null,
    portnumber: null,
    services: null,
    location: null,
    apikey: null,
    isSending: false,
    result: null,
    error: null,
    formIsValid: true,
    types: [
      { text: "Authorized Node", value: "authorized" },
      { text: "DUDE (Data Unit Distribution Executor)", value: "dude" }
    ],
    typeRules: [v => !!v || "Type is required"],
    ipaddressRules: [v => !!v || "IP Address is required"],
    portnumberRules: [v => !!v || "Port Number is required"],
    locationRules: [v => !!v || "Location is required"],
    apikeyRules: [v => !!v || "API Key is required"]
  }),
  computed: {
    dataRules: function() {
      return [
        v => !!v || "Data is required",
        () =>
          this.isDataJSON() ||
          this.type == "custom" ||
          "Data must be a valid JSON Object if type is 'custom'!"
      ];
    }
  },
  methods: {
    resetForm() {
      this.$refs.form.reset();
    },
    sendRequest: function() {
      this.isSending = true;
      let postData = {
        type: this.type,
        ip: this.ipaddress,
        port: this.portnumber,
        services: this.services,
        location: this.location
      };
      let headers = {
        "X-API-KEY": this.apikey
      };
      let axiosOptions = {
        headers: headers
      };
      API
        .post("/api/peers", postData, axiosOptions)
        .then(response => {
          this.isSending = false;
          if (response.data.error.length > 0) {
            this.error = response.data.error[0].message;
            return;
          }
          this.result = response.data;
          this.resetForm();
          this.displayResults = true;
        })
        .catch(reason => {
          this.error = reason;
          this.isSending = false;
          this.displayError = true;
        });
    },
    setSendingFalse: function() {
      this.isSending = false;
    }
  }
};
</script>

<style scoped>
 .v-subheader {
   color: var(--v-secondary-base);
   font-weight: 600;
   text-align: right;
 }
</style>